export const backgroundColor = '#FFFFFF'
//F5F5F5
//D5E8DD
//EAF3EE
//E2F3E8
export const headerColor = '#6C6FB2'
export const footerColor = 'indigo lighten-1'